export const mobileWidth = 500;